export function returnReducer(state = "",{
    type,
    payload
}){
    switch(type){
        
        case "GET_RETURN_PRODUCTS":
            return payload
        case "NEW_RETURN_PRODUCT":
            return {
                ...state,
                [payload.id]: payload
            }
        case "DELETE_RETURN_PRODUCT":
            const { [payload]: deleted, ...newState } = state;
            return newState;
        default:
            return state;
    }
    
}